import React from "react";
import { Divider, IconButton, Paper, Tooltip } from "@material-ui/core";
import LinkIcon from "@material-ui/icons/Link";
import RestoreIcon from "@material-ui/icons/Restore";
import styled from "styled-components/macro";

const Group = styled(Paper)`
  align-items: center;
  display: flex;
  height: 38px;
`;

const GroupButton = styled(IconButton)`
  border-radius: 0;
  height: 100%;
  padding: 6px 10px;
`;

/**
 * Grouped actions for the current map view: copy a link to it, or reset it
 * Icons keep the filter bar compact, the tooltips carry the meaning
 */
const ShareMapControls = ({ onCopyLink, onReset }) => {
  return (
    <Group variant="outlined">
      <Tooltip title="Copy a link to this map view, including filters, layers and position">
        <GroupButton
          color="primary"
          onClick={onCopyLink}
          aria-label="Copy a link to this map view"
        >
          <LinkIcon fontSize="small" />
        </GroupButton>
      </Tooltip>
      <Divider orientation="vertical" flexItem />
      <Tooltip title="Reset filters, layers and position to the defaults">
        <GroupButton
          onClick={onReset}
          aria-label="Reset the map to its defaults"
        >
          <RestoreIcon fontSize="small" />
        </GroupButton>
      </Tooltip>
    </Group>
  );
};

export default ShareMapControls;
